var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmartState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 14,
    viewBox: "0 0 95 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3162 8.33222L13.3178 5.84613L11.4219 4.78809L9.18258 6.02531L7.30493 9.38974L7.39353 12.0064L9.28934 13.0644L11.558 11.4825L13.3162 8.33222Z",
    fill: "#62718A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.699982 8.33222L0.698364 5.84613L2.59419 4.78809L4.83353 6.02531L6.71116 9.38974L6.62263 12.0064L4.72679 13.0644L2.45815 11.4825L0.699982 8.33222Z",
    fill: "#62718A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06338 5.40069L2.89172 4.19057V2.01948L5.06338 0.666992H8.9163L11.158 2.01948V4.19057L8.67114 5.40069H5.06338Z",
    fill: "#62718A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4979 2.27344H50.0619V10.1647L51.2704 11.3371L53.8082 11.3975V9.82651H51.4979V5.54163H53.2644V4.18552H51.4979V2.27344Z",
    fill: "#62718A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7444 5.49835L46.0341 4.14648H48.4907V5.49835H46.0341V11.3974H44.7444V5.49835Z",
    fill: "#62718A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.892 11.3974H24.2001V5.47582L25.5898 4.14648H28.6111L29.3966 4.87158L30.1217 4.14648H32.7804L33.9284 5.47582V11.3974H32.3574V5.47582H29.88V11.3974H28.3089V5.47582H25.892V11.3974Z",
    fill: "#62718A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8281 5.6582H20.8164L21.3358 6.08117L22.2061 5.1748L21.1185 4.20801H16.6396L15.3177 5.47692V7.10839L16.6396 8.49815H21.1185V10.0088H17.1909L16.4658 9.40452L15.5594 10.3713L16.6396 11.2777H21.3358L22.6289 10.0692V8.49815L21.3358 7.10839H16.8281V5.6582Z",
    fill: "#62718A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8016 5.1737L36.7684 6.20092L37.2518 5.71752H40.9377V7.04686H36.7684L35.4391 8.25535V9.94724L36.8893 11.3974H40.2126L41.3607 10.6119L41.9649 11.2766H43.2338V10.0077H42.5087V5.53625L41.3002 4.14648H36.7684L35.8016 5.1737ZM37.0705 8.49705H40.9377V9.52427L40.2126 9.94724H37.0705V8.49705Z",
    fill: "#62718A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4953 2.27344H68.0592V10.1648L69.2677 11.3371L71.8055 11.3975V9.82651H69.4953V5.54168H71.2617V4.18552H69.4953V2.27344Z",
    fill: "#62718A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7554 2.27344H82.3193V10.1648L83.5278 11.3371L86.0657 11.3975V9.82651H83.7554V5.54168H85.5218V4.18552H83.7554V2.27344Z",
    fill: "#62718A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8685 5.77831H64.8568L65.3762 6.20128L66.2466 5.29492L65.1589 4.32812H60.68L59.3582 5.59704V7.2285L60.68 8.61826H65.1589V10.1289H61.2313L60.5062 9.52463L59.5999 10.4914L60.68 11.3978H65.3762L66.6693 10.1893V8.61826L65.3762 7.2285H60.8685V5.77831Z",
    fill: "#62718A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5251 10.4922L93.4979 9.46495L92.8937 10.0692H88.9661V8.55858H93.0749L94.4043 7.35009V5.6582L92.9541 4.20801H88.9661L87.395 5.77905V10.0692L88.7244 11.459H93.4979L94.5251 10.4922ZM92.8937 5.77905H89.0265V7.35009H92.8937V5.77905Z",
    fill: "#62718A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4974 5.23523L74.4642 6.26244L74.9476 5.77905H78.6335V7.10839H74.4642L73.1349 8.31688V10.0088L74.5851 11.459H77.9084L79.0565 10.6734L79.6607 11.3381H80.9297V10.0692H80.2046V5.59777L78.9961 4.20801H74.4642L73.4974 5.23523ZM74.7664 8.55858H78.6335V9.58579L77.9084 10.0088H74.7664V8.55858Z",
    fill: "#62718A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartState);
export default __webpack_public_path__ + "static/media/smart_state.63198777fc16d24d8217b2c78ba1255d.svg";
export { ForwardRef as ReactComponent };